export const centerOptions = [
  {
    value: "143",
    label: "Specialty Surgical Oncology - Hospital & Research Centre",
  },
  { value: "182", label: "Infinity Medisurge Center" },
  {
    value: "213",
    label: "Specialty Surgical Oncology - Bellevue Multispeciality Hospital",
  },
  { value: "247", label: "Infinity Prime Speciality Hospital" },
  { value: "249", label: "Shankara Superspeciality Hospital" },
  { value: "264", label: "SSO Belgaum Cancer Hospital" },
];

// export const doctorOptions = [
//     { value: "Dr.Mitul Shah", label: "Dr.Mitul Shah" },
//     { value: "OT", label: "OT" },
//     { value: "SRL Diagnostics", label: "SRL Diagnostics" },
//     { value: "Dr.HD1", label: "Dr.HD1" },
//     { value: "Dr.HD2", label: "Dr.HD2" },
//     { value: "Dr.HD3", label: "Dr.HD3" },
//     { value: "Metropolis", label: "Metropolis" },
//     { value: "Aspira", label: "Aspira" },
//     { value: "Dr.Anil Dastur", label: "Dr.Anil Dastur" },
//     { value: "Bellevue Hospital", label: "Bellevue Hospital" },
//     { value: "Medical - Pink Pharma", label: "Medical - Pink Pharma" },
//     { value: "Surgical - Pink Pharma", label: "Surgical - Pink Pharma" },
//     { value: "Dr.J. G", label: "Dr.J. G" },
//     { value: "Dr.J. A", label: "Dr.J. A" },
//     { value: "Dr.Sanjay Gala", label: "Dr.Sanjay Gala" },
//     { value: "Dr.Mock", label: "Dr.Mock" },
//     { value: "Dr.Jay", label: "Dr.Jay" },
//     { value: "Dr.N C", label: "Dr.N C" },
//     { value: "Dr.Jay", label: "Dr.Jay" }
// ];

export const doctorOptions = [
  { value: "Dr. Sanket Mehta", label: "Dr. Sanket Mehta" },
  { value: "Dr. Haren Shah", label: "Dr. Haren Shah" },
  { value: "Dr. Rajan", label: "Dr. Rajan" },
  { value: "Dr. Abbasi", label: "Dr. Abbasi" },
  { value: "Dr. Abha Sanghvi", label: "Dr. Abha Sanghvi" },
  { value: "Dr. Abhishek Jaroli", label: "Dr. Abhishek Jaroli" },
  { value: "Dr. Ajay Thakkar", label: "Dr. Ajay Thakkar" },
  { value: "Dr. Akash Chheda", label: "Dr. Akash Chheda" },
  { value: "Dr. Akshay Deshpande", label: "Dr. Akshay Deshpande" },
  { value: "Dr. Akshay Shah", label: "Dr. Akshay Shah" },
  { value: "Dr. Alap Mehendale", label: "Dr. Alap Mehendale" },
  { value: "Dr. Amit Shah", label: "Dr. Amit Shah" },
  { value: "Dr. Amit Chakraborty", label: "Dr. Amit Chakraborty" },
  { value: "Dr. Amjad Khan Pathan", label: "Dr. Amjad Khan Pathan" },
  { value: "Dr. Amrut Vora", label: "Dr. Amrut Vora" },
  { value: "Dr. Ashok Dabir", label: "Dr. Ashok Dabir" },
  { value: "Dr. Avani Maniar", label: "Dr. Avani Maniar" },
  { value: "Dr. Babina Sharma", label: "Dr. Babina Sharma" },
  { value: "Dr. Bhaskar Shah", label: "Dr. Bhaskar Shah" },
  { value: "Dr. Bipin Shah", label: "Dr. Bipin Shah" },
  { value: "Dr. Carthikeyan S M", label: "Dr. Carthikeyan S M" },
  { value: "Dr. Chetan Anchan", label: "Dr. Chetan Anchan" },
  { value: "Dr. Chetan Jain", label: "Dr. Chetan Jain" },
  { value: "Dr. Chetan Kalal", label: "Dr. Chetan Kalal" },
  { value: "Dr. Chetan Velani", label: "Dr. Chetan Velani" },
  { value: "Dr. Chirag Dalal", label: "Dr. Chirag Dalal" },
  { value: "Dr. Chitranjan Das", label: "Dr. Chitranjan Das" },
  { value: "Dr. Darshan Doshi", label: "Dr. Darshan Doshi" },
  { value: "Dr. Deepak Bhadra", label: "Dr. Deepak Bhadra" },
  { value: "Dr. Deepak Shejol", label: "Dr. Deepak Shejol" },
  { value: "Dr. Deepti Desai", label: "Dr. Deepti Desai" },
  { value: "Dr. Devanshi Shah", label: "Dr. Devanshi Shah" },
  { value: "Dr. Devashri Shah", label: "Dr. Devashri Shah" },
  { value: "Dr. Dhara P Siodaria", label: "Dr. Dhara P Siodaria" },
  { value: "Dr. Dolly Doshi", label: "Dr. Dolly Doshi" },
  { value: "Dr. Esha Trivedi", label: "Dr. Esha Trivedi" },
  { value: "Dr. Ganesh Kini", label: "Dr. Ganesh Kini" },
  { value: "Dr. Gaurav Dhanawat", label: "Dr. Gaurav Dhanawat" },
  { value: "Dr. Gaurav shalya", label: "Dr. Gaurav shalya" },
  { value: "Dr. Gaurav Tomar", label: "Dr. Gaurav Tomar" },
  { value: "Dr. Gautam Tripathi", label: "Dr. Gautam Tripathi" },
  { value: "Dr. Hemant Pathankar", label: "Dr. Hemant Pathankar" },
  { value: "Dr. Hiren Pipalia", label: "Dr. Hiren Pipalia" },
  { value: "Dr. Hitesh Patel", label: "Dr. Hitesh Patel" },
  { value: "Dr. Jageshwar Pandey", label: "Dr. Jageshwar Pandey" },
  { value: "Dr. Jay Anam", label: "Dr. Jay Anam" },
  { value: "Dr. Jayesh Gori", label: "Dr. Jayesh Gori" },
  { value: "Dr. Jitesh Desai", label: "Dr. Jitesh Desai" },
  { value: "Dr. Jitesh Rajpurohit", label: "Dr. Jitesh Rajpurohit" },
  { value: "Dr. Juzer Mustansir Abbasi", label: "Dr. Juzer Mustansir Abbasi" },
  { value: "Dr. K. Davda", label: "Dr. K. Davda" },
  { value: "Dr. K. P. Dave", label: "Dr. K. P. Dave" },
  { value: "Dr. Kaival Gundawda", label: "Dr. Kaival Gundawda" },
  { value: "Dr. Kamlesh Bohra", label: "Dr. Kamlesh Bohra" },
  { value: "Dr. Kamran Khan", label: "Dr. Kamran Khan" },
  { value: "Dr. Kant Shah", label: "Dr. Kant Shah" },
  { value: "Dr. Karan Anandpara", label: "Dr. Karan Anandpara" },
  { value: "Dr. Karishma Kirti", label: "Dr. Karishma Kirti" },
  { value: "Dr. Keyur Sheth", label: "Dr. Keyur Sheth" },
  { value: "Dr. Kiran Pawar", label: "Dr. Kiran Pawar" },
  { value: "Dr. Kranti Mahajan", label: "Dr. Kranti Mahajan" },
  { value: "Dr. Kulin Shah", label: "Dr. Kulin Shah" },
  { value: "Dr. Kumar Doshi", label: "Dr. Kumar Doshi" },
  { value: "Dr. Kunal Shah", label: "Dr. Kunal Shah" },
  { value: "Dr. Kuntal Surana", label: "Dr. Kuntal Surana" },
  { value: "Dr. Mahek Punjabi", label: "Dr. Mahek Punjabi" },
  { value: "Dr. Mandar Gadgil", label: "Dr. Mandar Gadgil" },
  { value: "Dr. Mandar Ghadge", label: "Dr. Mandar Ghadge" },
  { value: "Dr. Mandar Kubal", label: "Dr. Mandar Kubal" },
  { value: "Dr. Mangesh Patil", label: "Dr. Mangesh Patil" },
  { value: "Dr. Manisha", label: "Dr. Manisha" },
  { value: "Dr. Maunil Bhuta", label: "Dr. Maunil Bhuta" },
  { value: "Dr. Meghav Shah", label: "Dr. Meghav Shah" },
  { value: "Dr. Mital Bhadra", label: "Dr. Mital Bhadra" },
  { value: "Dr. Mitesh Shah", label: "Dr. Mitesh Shah" },
  { value: "Dr. Mitul Shah", label: "Dr. Mitul Shah" },
  { value: "Dr. Mohan Kopikar", label: "Dr. Mohan Kopikar" },
  { value: "Dr. Mussadik Parkar", label: "Dr. Mussadik Parkar" },
  { value: "Dr. Nadem Shaikh", label: "Dr. Nadem Shaikh" },
  { value: "Dr. Natasha Tipnis", label: "Dr. Natasha Tipnis" },
  { value: "Dr. Neel Mehta", label: "Dr. Neel Mehta" },
  { value: "Dr. Niharika Garach", label: "Dr. Niharika Garach" },
  { value: "Dr. Niharika Gharich", label: "Dr. Niharika Gharich" },
  { value: "Dr. Niketa Kaulpawar", label: "Dr. Niketa Kaulpawar" },
  { value: "Dr. Nikhil Shah", label: "Dr. Nikhil Shah" },
  { value: "Dr. Nilesh Chordiya", label: "Dr. Nilesh Chordiya" },
  { value: "Dr. Nilesh Ghadge", label: "Dr. Nilesh Ghadge" },
  { value: "Dr. Nirav Chheda", label: "Dr. Nirav Chheda" },
  { value: "Dr. Nishad Goda", label: "Dr. Nishad Goda" },
  { value: "Dr. Nitin Bhorkar", label: "Dr. Nitin Bhorkar" },
  { value: "Dr. Parag Vaibhavkar", label: "Dr. Parag Vaibhavkar" },
  { value: "Dr. Parikshit Tank", label: "Dr. Parikshit Tank" },
  { value: "Dr. Parul D. Desai", label: "Dr. Parul D. Desai" },
  { value: "Dr. Piyush Gujarathi", label: "Dr. Piyush Gujarathi" },
  { value: "Dr. Pradnya Supe", label: "Dr. Pradnya Supe" },
  { value: "Dr. Prakash Pawar", label: "Dr. Prakash Pawar" },
  {
    value: "Dr. Pratik Bhupendrabhai Gopani",
    label: "Dr. Pratik Bhupendrabhai Gopani",
  },
  { value: "Dr. Praveen Kammar", label: "Dr. Praveen Kammar" },
  { value: "Dr. Prem Narasimhan", label: "Dr. Prem Narasimhan" },
  { value: "Dr. Pritish Maheshwari", label: "Dr. Pritish Maheshwari" },
  { value: "Dr. Priyanka Tatar", label: "Dr. Priyanka Tatar" },
  { value: "Dr. Pujan Parikh", label: "Dr. Pujan Parikh" },
  { value: "Dr. Quraysh Sadriwala", label: "Dr. Quraysh Sadriwala" },
  { value: "Dr. Rahul Sheth", label: "Dr. Rahul Sheth" },
  { value: "Dr. Rajan N. Modi", label: "Dr. Rajan N. Modi" },
  { value: "Dr. Rashmi Baliga", label: "Dr. Rashmi Baliga" },
  { value: "Dr. Rasik Patel", label: "Dr. Rasik Patel" },
  { value: "Dr. Raveena Shetty", label: "Dr. Raveena Shetty" },
  { value: "Dr. Ravindra Hadalkar", label: "Dr. Ravindra Hadalkar" },
  { value: "Dr. Ravindra Punamiya", label: "Dr. Ravindra Punamiya" },
  { value: "Dr. Reshma Shriyan", label: "Dr. Reshma Shriyan" },
  { value: "Dr. Riddhi Kataria", label: "Dr. Riddhi Kataria" },
  { value: "Dr. Riddhi Maniar", label: "Dr. Riddhi Maniar" },
  { value: "Dr. Ridham Shah", label: "Dr. Ridham Shah" },
  { value: "Dr. Ridhima Bindlish", label: "Dr. Ridhima Bindlish" },
  { value: "Dr. Rohan Basangar", label: "Dr. Rohan Basangar" },
  { value: "Dr. Rohit Barnabas", label: "Dr. Rohit Barnabas" },
  { value: "Dr. Ruchi Anam", label: "Dr. Ruchi Anam" },
  { value: "Dr. Ruju Gala", label: "Dr. Ruju Gala" },
  { value: "Dr. Sachet Chandak", label: "Dr. Sachet Chandak" },
  { value: "Dr. Sachet V Chandak", label: "Dr. Sachet V Chandak" },
  { value: "Dr. Sachin Bhojankar", label: "Dr. Sachin Bhojankar" },
  { value: "Dr. Sadashiv Chaudhari", label: "Dr. Sadashiv Chaudhari" },
  { value: "Dr. Sameer Kanakiya", label: "Dr. Sameer Kanakiya" },
  { value: "Dr. Sandeep Davawala", label: "Dr. Sandeep Davawala" },
  { value: "Dr. Sanjay Navalkar", label: "Dr. Sanjay Navalkar" },
  { value: "Dr. Sanjay Phadke", label: "Dr. Sanjay Phadke" },
  { value: "Dr. Sanket Mehta", label: "Dr. Sanket Mehta" },
  { value: "Dr. Sanmit joshi", label: "Dr. Sanmit joshi" },
  { value: "Dr. Santosh Patil", label: "Dr. Santosh Patil" },
  { value: "Dr. Sapna Kamdar", label: "Dr. Sapna Kamdar" },
  { value: "Dr. Sharad Mehta", label: "Dr. Sharad Mehta" },
  { value: "Dr. Shashank s", label: "Dr. Shashank s" },
  { value: "Dr. Shivam Jundre", label: "Dr. Shivam Jundre" },
  { value: "Dr. Shrikant Atlur", label: "Dr. Shrikant Atlur" },
  { value: "Dr. Shrikanth Atluri", label: "Dr. Shrikanth Atluri" },
  { value: "Dr. Shyam Mohan", label: "Dr. Shyam Mohan" },
  { value: "Dr. Siddhant Shetty", label: "Dr. Siddhant Shetty" },
  { value: "Dr. Siddharth Lakhani", label: "Dr. Siddharth Lakhani" },
  { value: "Dr. Siddharth Lalit Kumar", label: "Dr. Siddharth Lalit Kumar" },
  { value: "Dr. Snehal Panchal", label: "Dr. Snehal Panchal" },
  { value: "Dr. Soumi Mukharji", label: "Dr. Soumi Mukharji" },
  { value: "Dr. Sriniket Raghavan", label: "Dr. Sriniket Raghavan" },
  { value: "Dr. Suhas Aagre", label: "Dr. Suhas Aagre" },
  { value: "Dr. Sunil Sidana", label: "Dr. Sunil Sidana" },
  { value: "Dr. Sushilkumar Patil", label: "Dr. Sushilkumar Patil" },
  { value: "Dr. Swapnil Jain", label: "Dr. Swapnil Jain" },
  { value: "Dr. Tanvi Davda", label: "Dr. Tanvi Davda" },
  { value: "Dr. Tejas Dharia", label: "Dr. Tejas Dharia" },
  { value: "Dr. Tejsh Dharia", label: "Dr. Tejsh Dharia" },
  { value: "Dr. Udip Maheshwari", label: "Dr. Udip Maheshwari" },
  { value: "Dr. Ujjwal Yeole", label: "Dr. Ujjwal Yeole" },
  { value: "Dr. Umesh Vartam", label: "Dr. Umesh Vartam" },
  { value: "Dr. Umesh Varyani", label: "Dr. Umesh Varyani" },
  { value: "Dr. Urvi Maheshwari", label: "Dr. Urvi Maheshwari" },
  { value: "Dr. Vashishth Maniar", label: "Dr. Vashishth Maniar" },
  { value: "Dr. Veena Zaveri", label: "Dr. Veena Zaveri" },
  { value: "Dr. Vikas Pandey", label: "Dr. Vikas Pandey" },
  { value: "Dr. Vikrant Gosavi", label: "Dr. Vikrant Gosavi" },
  { value: "Dr. Vinod Pachade", label: "Dr. Vinod Pachade" },
  { value: "Dr. Viral Patrawala", label: "Dr. Viral Patrawala" },
  { value: "Dr. Vishwanathan Iyer", label: "Dr. Vishwanathan Iyer" },
  { value: "Dr. Vivek Sukumar", label: "Dr. Vivek Sukumar" },
  { value: "Dr. Yogesh Kini", label: "Dr. Yogesh Kini" },
  { value: "Dr. Zeeba Usofi", label: "Dr. Zeeba Usofi" },
  { value: "Dr.Hiten Dedia", label: "Dr.Hiten Dedia" },
  { value: "Dr.kamlesh", label: "Dr.kamlesh" },
  { value: "Dr.M.N Parkar", label: "Dr.M.N Parkar" },
  { value: "Dr.Ujwal yeole", label: "Dr.Ujwal yeole" },
  { value: "Dr. Hrishikesh", label: "Dr. Hrishikesh" },
  { value: "Dr. Jigar Zota", label: "Dr. Jigar Zota" },
  { value: "Dr. Malay Dave", label: "Dr. Malay Dave" },
  { value: "Dr. Nadeem", label: "Dr. Nadeem" },
  { value: "Dr. Neeraj Singh", label: "Dr. Neeraj Singh" },
  { value: "Dr. Nitin Shah", label: "Dr. Nitin Shah" },
  { value: "Dr. Saurabh Chalke", label: "Dr. Saurabh Chalke" },
  { value: "Dr. Deepa Patrawala", label: "Dr. Deepa Patrawala" },
  { value: "Dr. Hitesh Chaplot", label: "Dr. Hitesh Chaplot" },
  {
    value: "DR SANKET MEHTA / DR KEYUR SETH",
    label: "DR SANKET MEHTA / DR KEYUR SETH",
  },
  { value: "Dr. Aalap Mehendale", label: "Dr. Aalap Mehendale" },
  { value: "Dr. Abdulla Hamid", label: "Dr. Abdulla Hamid" },
  { value: "Dr. Abha Sanghavi", label: "Dr. Abha Sanghavi" },
  { value: "Dr. Abhay Nele", label: "Dr. Abhay Nele" },
  { value: "Dr. Ajay Thakkar", label: "Dr. Ajay Thakkar" },
  { value: "Dr. Ankit Shah", label: "Dr. Ankit Shah" },
  { value: "Dr. Ankita Mane", label: "Dr. Ankita Mane" },
  { value: "Dr. Arun Agarwal", label: "Dr. Arun Agarwal" },
  { value: "Dr. Bhargan Shah", label: "Dr. Bhargan Shah" },
  { value: "Dr. Brahmanand Chauhan", label: "Dr. Brahmanand Chauhan" },
  { value: "Dr. Chintan Patel", label: "Dr. Chintan Patel" },
  { value: "Dr. Chirag Bhansali", label: "Dr. Chirag Bhansali" },
  { value: "Dr. Chirag Chamria", label: "Dr. Chirag Chamria" },
  { value: "Dr. Chitra Pitale", label: "Dr. Chitra Pitale" },
  { value: "Dr. Deepak bhadra", label: "Dr. Deepak bhadra" },
  { value: "Dr. Dhruti Mahajan", label: "Dr. Dhruti Mahajan" },
  { value: "Dr. Dilip Bhonsale", label: "Dr. Dilip Bhonsale" },
  { value: "Dr. Dimple Chudghar", label: "Dr. Dimple Chudghar" },
  { value: "Dr. Egbert Saldana", label: "Dr. Egbert Saldana" },
  { value: "Dr. Gaurav Mishra", label: "Dr. Gaurav Mishra" },
  { value: "Dr. Gaurav Shalya", label: "Dr. Gaurav Shalya" },
  { value: "Dr. Hardeek Ghundiyal", label: "Dr. Hardeek Ghundiyal" },
  { value: "Dr. Harsh Sheth", label: "Dr. Harsh Sheth" },
  { value: "Dr. Hashmukh Patel", label: "Dr. Hashmukh Patel" },
  { value: "Dr. Hemant Patankar", label: "Dr. Hemant Patankar" },
  { value: "DR. Jay Anam", label: "DR. Jay Anam" },
  { value: "Dr. Jaydeep Tank", label: "Dr. Jaydeep Tank" },
  { value: "Dr. Karan Anand", label: "Dr. Karan Anand" },
  { value: "Dr. Karan Bhanushali", label: "Dr. Karan Bhanushali" },
  { value: "Dr. Ketaki Shah", label: "Dr. Ketaki Shah" },
  { value: "Dr. Kim Dsouza", label: "Dr. Kim Dsouza" },
  { value: "Dr. Krupesh Shah", label: "Dr. Krupesh Shah" },
  { value: "Dr. Manish Kothare", label: "Dr. Manish Kothare" },
  { value: "Dr. Manish Shah", label: "Dr. Manish Shah" },
  { value: "Dr. Manisha Ingale", label: "Dr. Manisha Ingale" },
  { value: "Dr. Maryam Qureshi", label: "Dr. Maryam Qureshi" },
  { value: "Dr. Maunil Bhutta", label: "Dr. Maunil Bhutta" },
  { value: "Dr. Mustansir Abbasi", label: "Dr. Mustansir Abbasi" },
  { value: "Dr. Narayani Kalnawat", label: "Dr. Narayani Kalnawat" },
  { value: "Dr. Narendra Bhoir", label: "Dr. Narendra Bhoir" },
  { value: "Dr. Nikhil Gokhale", label: "Dr. Nikhil Gokhale" },
  { value: "Dr. Nisha Jha", label: "Dr. Nisha Jha" },
  { value: "Dr. Nishant Gada", label: "Dr. Nishant Gada" },
  { value: "Dr. Nitin Gundre", label: "Dr. Nitin Gundre" },
  { value: "Dr. Nitin Jabak", label: "Dr. Nitin Jabak" },
  { value: "Dr. Pankaj Bhanushali", label: "Dr. Pankaj Bhanushali" },
  { value: "Dr. Parag Telavne", label: "Dr. Parag Telavne" },
  { value: "Dr. Parul Desai", label: "Dr. Parul Desai" },
  { value: "Dr. Piyush Modi", label: "Dr. Piyush Modi" },
  { value: "Dr. Pradip Joshi", label: "Dr. Pradip Joshi" },
  { value: "Dr. Prarek", label: "Dr. Prarek" },
  { value: "Dr. Preet Furia", label: "Dr. Preet Furia" },
  { value: "Dr. Pritesh Maheshwari", label: "Dr. Pritesh Maheshwari" },
  { value: "Dr. Priyanka Pawar", label: "Dr. Priyanka Pawar" },
  { value: "Dr. Priyesh Naik", label: "Dr. Priyesh Naik" },
  { value: "Dr. Rajan Garach", label: "Dr. Rajan Garach" },
  { value: "Dr. Raksha Chandak", label: "Dr. Raksha Chandak" },
  { value: "Dr. Rekha", label: "Dr. Rekha" },
  { value: "Dr. Rekha Ghadge", label: "Dr. Rekha Ghadge" },
  { value: "Dr. Reshma Rathod", label: "Dr. Reshma Rathod" },
  { value: "Dr. Rohan Bhiwgade", label: "Dr. Rohan Bhiwgade" },
  { value: "Dr. Rohan Khadtare", label: "Dr. Rohan Khadtare" },
  { value: "Dr. Ruta Bhoyar", label: "Dr. Ruta Bhoyar" },
  { value: "Dr. Rutuja Chavan", label: "Dr. Rutuja Chavan" },
  { value: "Dr. Saeeda Khan", label: "Dr. Saeeda Khan" },
  { value: "Dr. Samarth Thakkar", label: "Dr. Samarth Thakkar" },
  { value: "Dr. Sameer Karkhanis", label: "Dr. Sameer Karkhanis" },
  { value: "Dr. Sandeep Saboo", label: "Dr. Sandeep Saboo" },
  { value: "Dr. Sanjay Sonar", label: "Dr. Sanjay Sonar" },
  { value: "Dr. Sanket Nayak", label: "Dr. Sanket Nayak" },
  { value: "Dr. Sanmit Joshi", label: "Dr. Sanmit Joshi" },
  { value: "Dr. Shantaram Pawaskar", label: "Dr. Shantaram Pawaskar" },
  {
    value: "DR. SHARAD MEHTA / DR.RAJAN MODI",
    label: "DR. SHARAD MEHTA / DR.RAJAN MODI",
  },
  { value: "Dr. Shashank", label: "Dr. Shashank" },
  { value: "Dr. Shazia Waghoo", label: "Dr. Shazia Waghoo" },
  { value: "Dr. Shriniket Raghvan", label: "Dr. Shriniket Raghvan" },
  { value: "Dr. Shrushti Deshpande", label: "Dr. Shrushti Deshpande" },
  { value: "Dr. Sidhhant Jain", label: "Dr. Sidhhant Jain" },
  { value: "Dr. Simit Vora", label: "Dr. Simit Vora" },
  { value: "Dr. Sujit Nair", label: "Dr. Sujit Nair" },
  { value: "Dr. Sundaram C.", label: "Dr. Sundaram C." },
  { value: "Dr. Swarup Pal", label: "Dr. Swarup Pal" },
  { value: "Dr. Tanmay Joshi", label: "Dr. Tanmay Joshi" },
  { value: "Dr. Tanvi Zaki", label: "Dr. Tanvi Zaki" },
  { value: "Dr. Tarana Shaikh", label: "Dr. Tarana Shaikh" },
  { value: "Dr. Tejas Baviskar", label: "Dr. Tejas Baviskar" },
  { value: "Dr. Tejas Vispute", label: "Dr. Tejas Vispute" },
  { value: "Dr. Ujjay Jadhav", label: "Dr. Ujjay Jadhav" },
  { value: "Dr. Umang", label: "Dr. Umang" },
  { value: "Dr. Vikram Ghanekar", label: "Dr. Vikram Ghanekar" },
  { value: "Dr. Viraj Tambwekar", label: "Dr. Viraj Tambwekar" },
  { value: "Dr. Vivek Nikhumbha", label: "Dr. Vivek Nikhumbha" },
  { value: "Dr. Yusuf Mestry", label: "Dr. Yusuf Mestry" },
  { value: "Dr. Darshan Doshi", label: "Dr. Darshan Doshi" },
  { value: "DR RIDHAM SHAH", label: "DR RIDHAM SHAH" },
  { value: "Dr. Amit Sahu", label: "Dr. Amit Sahu" },
  { value: "Dr. Amit Shah", label: "Dr. Amit Shah" },
  { value: "Dr. Dhiren Pipalia", label: "Dr. Dhiren Pipalia" },
  { value: "Dr. kartikeyan", label: "Dr. kartikeyan" },
  { value: "Dr. Majhar Ali", label: "Dr. Majhar Ali" },
  { value: "Dr. Mandar Shingan", label: "Dr. Mandar Shingan" },
  { value: "Dr. Nadeem Shaikh", label: "Dr. Nadeem Shaikh" },
  { value: "Dr. Prerak Patel", label: "Dr. Prerak Patel" },
  { value: "Dr. SACHET CHANDAK", label: "Dr. SACHET CHANDAK" },
  { value: "Dr. saumil k. Shah", label: "Dr. saumil k. Shah" },
  { value: "Dr. Shivam", label: "Dr. Shivam" },
  { value: "Dr. Simit Vora", label: "Dr. Simit Vora" },
  { value: "Dr. Sushil Patil", label: "Dr. Sushil Patil" },
  { value: "Dr. Tanvi Jakhi", label: "Dr. Tanvi Jakhi" },
  { value: "Dr.Saumil Shah", label: "Dr.Saumil Shah" },
];

export const doctorsWithId = [
  { value: 760, label: "Dr. Sanket Mehta" },
  { value: 2741, label: "Dr. Homecare" },
  { value: 4491, label: "Dr. Amit Chakraborty" },
  { value: 3240, label: "Dr. Ankit Marfatia" },
  { value: 37071, label: "Dr. Arjun Susar" },
  { value: 25663, label: "Dr. Arvind Arora" },
  { value: 8008, label: "Dr. Aspira Center" },
  { value: 236, label: "Dr. Bar Sur Bariatric Surgeon Jr" },
  { value: 55971, label: "Dr. Bhavin Vadodariya" },
  { value: 2144, label: "Dr. Chetan Anchan" },
  { value: 628, label: "Dr. Deepak N. Bhatia" },
  { value: 1624, label: "Dr. Dhara Kapadia" },
  { value: 37070, label: "Dr. Gaurav Surana" },
  { value: 16, label: "Dr. General Physician" },
  { value: 1315, label: "Dr. Harsh Sheth" },
  { value: 9968, label: "Dr. Hemant B Telkar" },
  { value: 394, label: "Dr. Illume Imaging and Diagnostics" },
  { value: 9903, label: "Dr. Infinity Medical Centre" },
  { value: 5404, label: "Dr. IZEN Imaging and Interventions" },
  { value: 37235, label: "Dr. J J Jain" },
  { value: 1345, label: "Dr. Jafferhusein Sura" },
  { value: 1401, label: "Dr. Jay R Anam" },
  { value: 2751, label: "Dr. Jayesh Gori" },
  { value: 40851, label: "Dr. Joyce Thomas" },
  { value: 81, label: "Dr. Kamlesh Jariwala" },
  { value: 2151, label: "Dr. Kamran Khan" },
  { value: 26215, label: "Dr. Karishma Kirti" },
  { value: 36935, label: "Dr. Ketan Jain" },
  { value: 5403, label: "Dr. Khushboo Pilania Agrawal" },
  { value: 8074, label: "Dr. Kiran Thorat" },
  { value: 6812, label: "Dr. Krisha Vira" },
  { value: 25813, label: "Dr. Krupa Doshi" },
  { value: 25754, label: "Dr. Manasi Shintre Rajadhyaksha" },
  { value: 26435, label: "Dr. Manjeet Kumar" },
  { value: 6, label: "Dr. Mike Behar" },
  { value: 404, label: "Dr. Muffazal Lakdawala" },
  { value: 25919, label: "Dr. Nandan Marathe" },
  { value: 164, label: "Dr. Nihar Mehta" },
  { value: 2820, label: "Dr. Nilesh Chordiya" },
  { value: 33964, label: "Dr. Nirman Hitech Diagnostic Centre" },
  { value: 35477, label: "Dr. Nivaran Diagnostic Centre" },
  { value: 38243, label: "Dr. Nivaran Excellence Centre" },
  { value: 9971, label: "Dr. Parag Aland" },
  { value: 25614, label: "Dr. Parimal Malviya" },
  { value: 399, label: "Dr. Pascal DeNiese" },
  { value: 34492, label: "Dr. Pascal DeNiese SD" },
  { value: 17766, label: "Dr. Pettarusp Wadia" },
  { value: 2728, label: "Dr. Picture This by Jhankaria" },
  { value: 1, label: "Dr. Pranay Paresh Majmundar" },
  { value: 1402, label: "Dr. Praveen Kammar" },
  { value: 36933, label: "Dr. Primacare Diagnostics" },
  { value: 42527, label: "Dr. Priyanka Rajiv" },
  { value: 494, label: "Dr. Rais Ansari" },
  { value: 2171, label: "Dr. Richard Pereira" },
  { value: 25613, label: "Dr. Rupali Kuckian" },
  { value: 26, label: "Dr. Sachi Puri Desai" },
  { value: 25892, label: "Dr. Saloni Shukla" },
  { value: 19, label: "Dr. Sanjay Gala" },
  { value: 760, label: "Dr. Sanket Mehta" },
  { value: 36936, label: "Dr. Sanket Jain" },
  { value: 36682, label: "Dr. Shadaab Shaikh" },
  { value: 25725, label: "Dr. Shailey Chheda" },
  { value: 1487, label: "Dr. Shreyansh Kothari" },
  { value: 57, label: "Dr. Shreyansh Suren Kothari" },
  { value: 235, label: "Dr. Sonam Solanki" },
  { value: 8073, label: "Dr. Specialty Oncopathology Centre" },
  { value: 5229, label: "Dr. Team Digestive Health" },
  { value: 17124, label: "Dr. Tejal Menon" },
  { value: 8101, label: "Dr. Vikash Kumar Agarwal" },
  { value: 8863, label: "Dr. Vivek Sukumar" },
  { value: 6283, label: "Dr. Jageshwar Pandey" },
];
